import Form from "@/components/Form";
import LocaleText from "@/components/Intl/LocaleText";

import { ECustomerEnvironment } from "@/helpers/API/requests/interfaces/customer";

import { TPersonalizationStepForm } from "./interfaces";
import Layout from "./Layout";

const Environment: React.FC<TPersonalizationStepForm> = ({ formRef }) => {
  return (
    <Layout title="form.personalizationStep.environment.title">
      {Object.values(ECustomerEnvironment).map((value) => (
        <Form.RadioButton
          key={value}
          name="environment"
          value={value}
          onChanged={() => {
            formRef.current!.next();
          }}
        >
          <LocaleText>{"form.personalizationStep.radio." + value}</LocaleText>
        </Form.RadioButton>
      ))}
    </Layout>
  );
};

export default Environment;
